import React from "react"

import { Row, Col } from 'antd'

import logoWhite from '../assets/images/image_logo_new_white_event.png'

export default function EventFooter(props) {
    const { event } = props

    return (
        <div className="event-footer">
            <Row type="flex" justify="center">
                <p className="event-footer-title">{event.title}</p>
            </Row>

            <Row type="flex" justify="center" align="middle">
                <Row type="flex" justify="center" align="middle" className="event-footer-organizer">
                    <Col span={8}>
                        <p className="event-footer-organizer-title">主辦單位：</p>
                    </Col>
                    <Col span={16}>
                        <a href="/">
                            <Row type="flex" justify="center">
                                <img src={logoWhite} className="event-footer-organizer-logo" alt="logo" />
                            </Row>

                            <Row type="flex" justify="center">
                                <p className="event-footer-organizer-company">享狩數據科技有限公司</p>
                            </Row>
                        </a>
                    </Col>

                </Row>
            </Row>
        </div>

    )
}